/*------------------------------------------------------------------
Import external
------------------------------------------------------------------*/

import $ from 'jquery';
import slick from 'slick-carousel';

/*------------------------------------------------------------------
Doc Ready
------------------------------------------------------------------*/

$(() => {


    let $linkBlock = $('.js-gallery-slider');
    let $linkBlockProgress = $('.js-gallery-progress');

    $linkBlock.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
        $linkBlockProgress.css({ width: `${((currentSlide || 0) + 1) / slick.slideCount * 100}%` })
    });

    $linkBlock.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        centerMode: true,
        infinite: true,
        centerPadding: '20%',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '2%',
                }
            },
        ]
    });

    $('.js-gallery-slider-prev').on('click', (e) => {
        e.preventDefault();
        $linkBlock.slick('slickPrev');
    });

    $('.js-gallery-slider-next').on('click', (e) => {
        e.preventDefault();
        $linkBlock.slick('slickNext');
    });


    let $miniSlider = $('.js-mini-slider');

    if ($miniSlider.length) {
        console.log(slick)

        $miniSlider.slick({
            dots: false,
            arrows: true,
            prevArrow: `<a href="#" class="vehicle__wrap__imagery__slider__control vehicle__wrap__imagery__slider__control--prev"><svg width="30" height="30" xmlns="http://www.w3.org/2000/svg"><path d="M25 0a5 5 0 0 1 5 5v20a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h20zM10 15.114l.762.876 7.25 8.239L20 22.478l-6.478-7.364L20 7.751 18.012 6l-7.25 8.239-.762.875z" fill="#DF542F" fill-rule="evenodd"/></svg></a>`,
            nextArrow: `<a href="#" class="vehicle__wrap__imagery__slider__control vehicle__wrap__imagery__slider__control--next"><svg width="30" height="30" xmlns="http://www.w3.org/2000/svg"><path d="M5 0h20a5 5 0 0 1 5 5v20a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5zm15 15.114l-.762-.875L11.988 6 10 7.75l6.478 7.364L10 22.478l1.988 1.75 7.25-8.238.762-.876z" fill="#DF542F" fill-rule="evenodd"/></svg></a>`,
            infinite: true,
            slidesToShow: 1
        });
    }

});

